import deviceApi from '@/api/deviceApi'

const SET_DEVICE_LIST = 'setDeviceList'
const SET_DEVICE_COUNT = 'setDeviceCount'

const state = {
  deviceList: [],
  deviceCount: 0
}

const mutations = {
  [SET_DEVICE_LIST] (state, deviceList) {
    state.deviceList = deviceList
  },

  [SET_DEVICE_COUNT] (state, deviceCount) {
    state.deviceCount = deviceCount
  }
}

const actions = {
  getDevices ({ commit }, data) {
    return new Promise((resolve, reject) => {
      deviceApi.getDevices(data.page, data.pageSize,
        data.sort, data.filters).then(res => {
        if (res && res.rcode === 0) {
          commit(SET_DEVICE_LIST, res.data.devices)
          commit(SET_DEVICE_COUNT, res.data.count)
          resolve(res)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  updateDevice ({ commit }, data) {
    return new Promise((resolve, reject) => {
      deviceApi.updateDevice(data.sn, data.type,
        data.protocol, data.conn_encry, data.first_alive, data.game_notify).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  unbind ({ commit }, data) {
    return new Promise((resolve, reject) => {
      deviceApi.unbind(data.sn).then(res => {
        if (res && res.rcode === 0) {
          resolve(res)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  async batchUnbind ({ commit }, data) {
    try {
      return await deviceApi.batchUnbind(data.sns)
    } catch (err) {
      return err
    }
  },
  async batchMigrate ({ commit }, data) {
    try {
      return await deviceApi.batchMigrate(data.sns, data.userid, data.title, data.type)
    } catch (err) {
      return err
    }
  },
  bindUrl ({ commit }, data) {
    return new Promise((resolve, reject) => {
      deviceApi.bindUrl(data.clientid, data.iccid).then(res => {
        if (res && res.rcode === 0) {
          resolve(res)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  batchAdd ({ commit }, data) {
    return new Promise((resolve, reject) => {
      deviceApi.batchAdd(data.userid, data.clientids, data.type, data.title,
        data.platform, data.protocol, data.connEncry, data.factoryId).then(res => {
        if (res && res.rcode === 0) {
          resolve(res)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  remoteUpgrade ({ commit }, data) {
    return new Promise((resolve, reject) => {
      deviceApi.remoteUpgrade(data.sn, data.dev, data.init, data.type).then(res => {
        if (res && res.rcode === 0) {
          resolve(res)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/device.js